// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PHOTO_UPLOAD_ABORTED_UPLOAD = "P\u0159eru\u0161en\u00e9";
export const PHOTO_UPLOAD_FILE_IS_TOO_BIG = "Soubor je p\u0159\u00edli\u0161 velk\u00fd";
export const PHOTO_UPLOAD_WRONG_IMAGE_FORMAT = "Nespr\u00e1vn\u00fd typ souboru. M\u00e1 m\u00edt p\u0159\u00edponu JPG, PNG nebo GIF";
